import React, { useEffect, useRef, useState, useContext } from 'react'
import { DownloadTableExcel } from 'react-export-table-to-excel';
import MsgUtils from '../Tools/MsgUtils';
import DateConverter from '../Tools/DateConverter';
import Modal from 'react-bootstrap/Modal';
import DetallePedido from './DetallePedido';
import GraficoMotos from './GraficoMotos';
import { ContextGloball } from '../Context/ContextGlobal';
import GraficaMotosDos from './GraficaMotosDos';
import ResumenMotos from './ResumenMotos';
import VerificarPermisos from '../Tools/VerificarPermisos'
import ConfigurarEnvioReporte from './ConfigurarEnvioReporte';
import GraficaCallCenter from './GraficaCallCenter';
const server = process.env.REACT_APP_SERVER;
function ControlMotosPrincipal() {
    const { loading, setLoading } = useContext(ContextGloball)
    const [regional, setRegional] = useState(JSON.parse(localStorage.getItem('__react_session__')).regional);
    const [sucursales, setSucursales] = useState([]);
    const [idSucursal, setIdSucursal] = useState(0);
    const [fecha, setFecha] = useState('');
    const [conectado, setConectado] = useState(false);
    const [pedidos, setPedidos] = useState([]);
    const [valMaximo, setValMaximo] = useState(0);
    const [valMaximoD, setValMaximoD] = useState(0);
    const [valMaximoMoto, setValMaximoMoto] = useState(0);
    const [motoPedido, setMotoPedido] = useState([]);
    const [datosOn, setDatosOn] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [showDetalle, setShowDetalle] = useState(false);
    const [showVerMoto, setShowVerMoto] = useState(false);
    const [selectItem, setSelectItem] = useState({});
    const [sucursalSelect, setSelectSucursal] = useState({});
    const [motosPorHora, setMotosPorHora] = useState([]);
    const [selectMotoHora, setSelectMotoHora] = useState([]);
    const [tipoModal, setTipoModal] = useState('');
    const [ventana, setVentana] = useState(0);
    const tableRef = useRef();
    const getColor = (valor, max) => {
        var P = (valor / max);
        var R = Math.round(0xFF * (P));
        var G = Math.round(0xFF * (1 - P));
        var B = 0x00;
        return '#' + R.toString(16).padStart(2, '0') + G.toString(16).padStart(2, '0') + B.toString(16).padStart(2, '0');
    }
    const verDetalle = (dato) => {
        setTipoModal('D');
        setSelectItem(dato);
        setShowDetalle(true);
    }
    const desconectarSucursalAnterior = (info) => {
        fetch(`${server}/dbConectar/desconectar`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                info: { ...info[0], idUsuario: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO }
            })
        })
            .then(res => res.json())
            .then(data => {
                MsgUtils.msgCorrecto(data.ok);
            })
            .catch(err => MsgUtils.msgError(err));
    }
    const ordenarLista = (valor) => {
        setDatosOn(false);
        var ordenado = pedidos.sort(function (a, b) {
            if (a.DIFF > b.DIFF) {
                return valor ? 1 : -1;
            }
            if (a.DIFF < b.DIFF) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setPedidos(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const ordenarListaPedido = (valor) => {
        setDatosOn(false);
        var ordenado = pedidos.sort(function (a, b) {
            if (a.PEDIDO_NRO > b.PEDIDO_NRO) {
                return valor ? 1 : -1;
            }
            if (a.PEDIDO_NRO < b.PEDIDO_NRO) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setPedidos(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const ordenarListaTimeMoto = (valor) => {
        setDatosOn(false);
        var ordenado = pedidos.sort(function (a, b) {
            if (a.RETRASO_MOTO > b.RETRASO_MOTO) {
                return valor ? 1 : -1;
            }
            if (a.RETRASO_MOTO < b.RETRASO_MOTO) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setPedidos(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const ordenarListaTimeDespacho = (valor) => {
        setDatosOn(false);
        var ordenado = pedidos.sort(function (a, b) {
            if (a.RETRASO_DS > b.RETRASO_DS) {
                return valor ? 1 : -1;
            }
            if (a.RETRASO_DS < b.RETRASO_DS) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setPedidos(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const ordenarListaMoto = (valor) => {
        setDatosOn(false);
        var ordenado = motoPedido.sort(function (a, b) {
            if (a.PEDIDOS > b.PEDIDOS) {
                return valor ? 1 : -1;
            }
            if (a.PEDIDOS < b.PEDIDOS) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setMotoPedido(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const ordenarListaMotoTiempo = (valor) => {
        setDatosOn(false);
        var ordenado = motosPorHora.sort(function (a, b) {
            if (a.cantidad > b.cantidad) {
                return valor ? 1 : -1;
            }
            if (a.cantidad < b.cantidad) {
                return valor ? -1 : 1;
            }
            // a must be equal to b
            return 0;
        });
        setMotosPorHora(ordenado);
        setDatosOn(true);
        setActualizar(!actualizar);
    }
    const conectarmeSucursal = (valor) => {
        if (idSucursal != 0) {
            desconectarSucursalAnterior(sucursales.filter(item => item.ID_SUCURSAL == idSucursal));
        }
        setIdSucursal(valor);
        var info = sucursales.filter(item => item.ID_SUCURSAL == valor);
        setSelectSucursal({ ...info[0], idUsuario: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO });
        if (valor != 0) {
            fetch(`${server}/dbConectar/conectar`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    info: { ...info[0], idUsuario: JSON.parse(localStorage.getItem('info')).ID_EMPLEADO }
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (data.ok) {
                        setConectado(true);
                    } else {
                        setConectado(false);
                    }
                    setDatosOn(false);
                })
                .catch(err => MsgUtils.msgError(err));
        } else {
            setConectado(false);
        }
    }
    const BuscarInformacionMoto = () => {
        setLoading(true);
        setDatosOn(false);
        var info = sucursales.filter(item => item.ID_SUCURSAL == idSucursal)[0];
        fetch(`${server}/reporte/getControlMotos`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                idUsuario: JSON.parse(localStorage.getItem('__react_session__')).idSession, fecha, info
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    console.log(data.ok)
                    var info = data.ok.MOTOS;
                    var infoTiempo = data.ok.TIEMPOMOTO;
                    var horaIni = new Date(data.ok.TIEMPOMOTO[0].FECHA_HORA);
                    var motoshora = []; //horaini-horafin-listamotos-cantidad
                    var aux = { "horaini": 0, "horafin": 0, "listamoto": [], "cantidad": 0 };
                    for (var i = 0; i < infoTiempo.length; i++) {
                        var horafin = new Date(infoTiempo[i].FECHA_HORA);
                        if ((horaIni.getHours() == horafin.getHours())) {
                            if (aux.horaini === 0) {
                                aux = { "horaini": horaIni, "horafin": null, "listamoto": [infoTiempo[i]], "cantidad": 1 }
                            } else {
                                if (aux.listamoto.filter((item) => item.ID_MOTO === infoTiempo[i].ID_MOTO).length === 0) {
                                    aux.cantidad = aux.cantidad + 1;
                                    aux.listamoto.push(infoTiempo[i]);
                                }
                            }
                        } else {
                            horaIni = horafin;
                            aux.horafin = horafin;
                            motoshora.push(aux);
                            aux = { "horaini": horaIni, "horafin": null, "listamoto": [infoTiempo[i]], "cantidad": 1 };
                        }
                        if (i === infoTiempo.length - 1) {
                            motoshora.push(aux);
                        }
                    }
                    setMotosPorHora(motoshora);
                    setPedidos(info);
                    var max = 0, maxMot = 0, maxDes = 0;
                    var motos = [{ ...info[0], "PEDIDOS": info.filter((item) => item.ID_MOTO === info[0].ID_MOTO).length }];
                    for (var i = 0; i < info.length; i++) {
                        if (maxMot < info[i].RETRASO_MOTO) {
                            maxMot = info[i].RETRASO_MOTO;
                        }
                        if (maxDes < info[i].RETRASO_DS) {
                            maxDes = info[i].RETRASO_DS;
                        }
                        if (max < info[i].DIFF) {
                            max = info[i].DIFF
                        }
                        if (motos.filter((item) => item.ID_MOTO == info[i].ID_MOTO).length == 0) {
                            motos.push({ ...info[i], "PEDIDOS": info.filter((item) => item.ID_MOTO === info[i].ID_MOTO).length })
                        }
                    }
                    setValMaximoD(maxDes);
                    setValMaximo(max);
                    setValMaximoMoto(maxMot);
                    setMotoPedido(motos);
                    setDatosOn(true);
                }
                setLoading(false);
            })
            .catch(err => { MsgUtils.msgError("No existen registos de motos para esta sucursal y fecha"); setLoading(false) });
    }
    const verMotos = (dato) => {
        setSelectMotoHora(dato.listamoto);
        setShowVerMoto(true);
    }
    function buscarColaborador() {
        var input, filter, table, tr, td, i, txtValue, div;
        input = document.getElementById("buscarMoto");
        filter = input.value.toUpperCase();
        table = document.getElementById("listaMotos");
        tr = table.getElementsByTagName("tr");
        for (i = 0; i < tr.length; i++) {
            td = tr[i].getElementsByTagName("td")[5];
            if (td) {
                //txtValue = td.getElementsByTagName('div')[1].getElementsByTagName('div')[0].innerHTML;
                txtValue = td.textContent || td.innerText;
                if (txtValue.toUpperCase().indexOf(filter) > -1) {
                    tr[i].style.display = "";
                } else {
                    tr[i].style.display = "none";
                }
            }
        }
    }
    function getDetallePedido(dato) {
        return (
            <div className='contianer-fluid text-start' style={{ fontSize: '11px' }}>
                {dato.DETALLE.map((vaa, index) => {
                    return (
                        <div key={index}>
                            {vaa.CANTIDAD + ' - ' + vaa.DESCRIPCION}
                        </div>
                    )
                })}
            </div>
        )
    }
    useEffect(() => { }, [actualizar])
    useEffect(() => {
        if (fecha == '') {
            setFecha(new Date().toISOString().substring(0, 10))
        }
        fetch(`${server}/sqlComun/sucursalesColl`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional: JSON.parse(localStorage.getItem('__react_session__')).regional,
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.err) {
                    MsgUtils.msgError(data.error);
                } else {
                    setSucursales(data.ok);
                }
                //setLoading(false);
            })
            .catch(err => MsgUtils.msgError(err));
    }, [])
    return (
        <div id='graficosPrueba'>
            <div className='container-fluid bg-dark bg-gradient py-1'>
                {ventana != 2 && <div className='row row-cols g-1' style={{ marginRight: '40px' }}>
                    <div className='col-6 col-md-3 col-lg-2 col-xl-2 col-xxl-2 d-none'>
                        <div className="input-group input-group-sm my-auto ">
                            <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Regional</span>
                            <select className=" form-select text-center" value={regional} onChange={(e) => setRegional(e.target.value)} >
                                <option value='990'>CBBA</option>
                                <option value='991'>SCRZ</option>
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '180px', minWidth: '180px' }}>
                        <div className="input-group input-group-sm my-auto" >
                            <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Sucursal</span>
                            <select className=" form-select text-center" value={idSucursal} onChange={(e) => conectarmeSucursal(e.target.value)}>
                                <option value={0}>NINGUNO</option>
                                {sucursales.map((item, index) => {
                                    return (
                                        <option value={item.ID_SUCURSAL} key={index}>{item.SUCURSAL}</option>
                                    )
                                })}
                            </select>
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '180px', minWidth: '180px' }}>
                        <div className="input-group input-group-sm my-auto" >
                            <span className="input-group-text bg-dark bg-gradient text-light border-dark" >Fecha</span>
                            <input className='form-control form-control-sm' type="date"
                                value={fecha} onChange={(e) => setFecha(e.target.value)} />
                        </div>
                    </div>
                    <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
                        <button className='btn btn-sm btn-secondary bg-gradient w-100' disabled={!conectado}
                            onClick={() => BuscarInformacionMoto()}>
                            <i className="fa-solid fa-arrows-spin"></i> Buscar
                        </button>
                    </div>
                    {datosOn && <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
                        <input type="text" className="form-control form-control-sm w-100" id="buscarMoto" placeholder='Buscar Moto'
                            onChange={() => buscarColaborador()} />
                    </div>}
                    {datosOn && <div className='col' style={{ maxWidth: '100px', minWidth: '100px' }}>
                        <DownloadTableExcel
                            filename="Reporte motos"
                            sheet="Reporte"
                            currentTableRef={tableRef.current}
                        >
                            <button className='btn btn-sm btn-success w-100'><i className="fa-solid fa-file-excel"></i> Excel</button>

                        </DownloadTableExcel></div>}
                    {datosOn && <div className='col' style={{maxWidth:'100px',minWidth:'100px'}}>
                        <div className='btn-group'>
                            {(ventana == 0 || ventana == 3) && <button className='btn btn-sm btn-secondary bg-gradient'
                                title='Ver solo Graficas'
                                onClick={() => setVentana(ventana == 0 ? 1 : 0)}>
                                <i className="fa-solid fa-chart-area"></i>
                            </button>}
                            {ventana == 1 && <button className='btn btn-sm btn-secondary bg-gradient'
                                title='Ver resumen Completo'
                                onClick={() => setVentana(ventana == 0 ? 1 : 0)}>
                                <i className="fa-solid fa-file-lines"></i>
                            </button>}
                            <button className='btn btn-light btn-sm'
                                title='Grafica motos Tiempo log'
                                onClick={() => { setVentana(3) }}>
                                <i className="fa-solid fa-chart-line"></i>
                            </button>
                            <button className='btn btn-success btn-sm'
                                title='Generar Resumen en PDF'
                                onClick={() => { setTipoModal('R'); setShowDetalle(true) }}>
                                <i className="fa-solid fa-file-pdf"></i>
                            </button>
                            {VerificarPermisos.validarPermiso('43') && <button className='btn btn-info btn-sm'
                                title='Configuración de los envios a los correos'
                                onClick={() => setVentana(2)}>
                                <i className="fa-solid fa-gears"></i>
                            </button>}
                        </div>
                    </div>}
                </div>}
            </div>
            {ventana == 0 && <>
                {datosOn && <GraficoMotos pedidos={pedidos} valMaximo={valMaximo} tipo={'R'} />}
                {datosOn && <GraficoMotos pedidos={pedidos} valMaximo={valMaximoMoto} tipo={'M'} />}
                {datosOn &&
                    <div className='py-2'>
                        <div className='table-responsive overflow-auto' style={{ height: "600px" }}>
                            <table className="table table-dark table-sm " id='listaMotos' ref={tableRef}>
                                <thead>
                                    <tr className='text-center'>
                                        <th style={{ minWidth: '110px', maxWidth: '110px' }}>
                                            <div className='container-fluid m-0 p-0'>
                                                <div className='row row-cols-md-2 g-1'>
                                                    <div className='col col-md-8 m-0 p-0'>
                                                        #Pedido
                                                    </div>
                                                    <div className='col col-md-4 m-0 p-0'>
                                                        <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                            onClick={() => ordenarListaPedido(true)}>
                                                            <i className="fa-solid fa-sort-up"></i>
                                                        </button>
                                                        <button className='btn btn-sm m-0 p-0 text-light'
                                                            onClick={() => ordenarListaPedido(false)}>
                                                            <i className="fa-solid fa-caret-down"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div></th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>Hora Llamada</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>Hora Factura</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>Cajera</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>Total [Bs]</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>Productos</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>
                                            <div className='container-fluid m-0 p-0'>
                                                <div className='row row-cols-md-2 g-1'>
                                                    <div className='col col-md-8 m-0 p-0'>
                                                        T Fac
                                                    </div>
                                                    <div className='col col-md-4 m-0 p-0'>
                                                        <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                            onClick={() => ordenarLista(true)}>
                                                            <i className="fa-solid fa-sort-up"></i>
                                                        </button>
                                                        <button className='btn btn-sm m-0 p-0 text-light'
                                                            onClick={() => ordenarLista(false)}>
                                                            <i className="fa-solid fa-caret-down"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </th>
                                        <th style={{ minWidth: '100px', maxWidth: '100px' }}>Moto</th>
                                        <th style={{ minWidth: '120px', maxWidth: '120px' }}>
                                            <div className='container-fluid m-0 p-0'>
                                                <div className='row row-cols-md-2 g-1'>
                                                    <div className='col col-md-8 m-0 p-0'>
                                                        T Desp
                                                    </div>
                                                    <div className='col col-md-4 m-0 p-0'>
                                                        <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                            onClick={() => ordenarListaTimeDespacho(true)}>
                                                            <i className="fa-solid fa-sort-up"></i>
                                                        </button>
                                                        <button className='btn btn-sm m-0 p-0 text-light'
                                                            onClick={() => ordenarListaTimeDespacho(false)}>
                                                            <i className="fa-solid fa-caret-down"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </th>
                                        <th className=" d-none" style={{ minWidth: '120px', maxWidth: '120px' }}>
                                            <div className='container-fluid m-0 p-0'>
                                                <div className='row row-cols-md-2 g-1'>
                                                    <div className='col col-md-8 m-0 p-0'>
                                                        T Moto
                                                    </div>
                                                    <div className='col col-md-4 m-0 p-0'>
                                                        <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                            onClick={() => ordenarListaTimeMoto(true)}>
                                                            <i className="fa-solid fa-sort-up"></i>
                                                        </button>
                                                        <button className='btn btn-sm m-0 p-0 text-light'
                                                            onClick={() => ordenarListaTimeMoto(false)}>
                                                            <i className="fa-solid fa-caret-down"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </th>
                                        <th style={{ minWidth: '140px', maxWidth: '140px' }}>Dirección</th>
                                        <th style={{ minWidth: '80px', maxWidth: '80px' }}>Detalle</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pedidos.map((item, index) => {
                                        return (
                                            <tr key={index} className="text-center text-light" >
                                                <th scope="row">{item.PEDIDO_NRO}</th>
                                                <td>{DateConverter.formatoHora(item.LLAMADA_HORA)}</td>
                                                <td>{DateConverter.formatoHora(item.FECHA)}</td>
                                                <td style={{ fontSize: '11px' }}>{item.NOMBRE_CAJERA}</td>
                                                <td>{item.TOTAL}</td>
                                                <td>{getDetallePedido(item)}
                                                </td>
                                                <td style={{ "--bs-table-bg": `${getColor(item.DIFF, valMaximo)}`, "--bs-table-hover-bg": '#ffffff' }}>{item.DIFF} min</td>
                                                <td>{item.MOTO}</td>
                                                <td style={{ "--bs-table-bg": `${getColor(item.RETRASO_DS, valMaximoD)}`, "--bs-table-hover-bg": '#ffffff' }}>{item.RETRASO_DS} min</td>
                                                <td className='d-none' style={{ "--bs-table-bg": `${getColor(item.RETRASO_MOTO == null ? 0 : item.RETRASO_MOTO, valMaximoMoto)}`, "--bs-table-hover-bg": '#ffffff' }}>{item.RETRASO_MOTO} min</td>
                                                <td style={{ fontSize: '9px' }}>{item.DIRECCION}</td>
                                                <td>
                                                    <button className='btn btn-sm btn-secondary' onClick={() => verDetalle(item)}>
                                                        detalle
                                                    </button>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>}
                {datosOn &&
                    <div className='container-fluid'>
                        <div className='row row-cols-1 row-cols-sm-1 row-cols-md-2 g-0 '>
                            <div className='col m-0 p-0'>
                                <div className='container-fluid text-center bg-secondary text-light bg-gradient'>
                                    Promedio Pedidos Moto
                                </div>
                                <div className='table-responsive overflow-auto' style={{ height: "350px" }}>
                                    <table className="table table-sm table-dark table-hover table-striped">
                                        <thead>
                                            <tr className='text-center'>
                                                <th className="col-3">Moto</th>
                                                <th className="col">
                                                    <div className='container-fluid m-0 p-0'>
                                                        <div className='row row-cols-2 g-1'>
                                                            <div className='col-8 m-0 p-0'>
                                                                Total Pedidos
                                                            </div>
                                                            <div className='col-4 m-0 p-0'>
                                                                <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                                    onClick={() => ordenarListaMoto(true)}>
                                                                    <i className="fa-solid fa-sort-up"></i>
                                                                </button>
                                                                <button className='btn btn-sm m-0 p-0 text-light'
                                                                    onClick={() => ordenarListaMoto(false)}>
                                                                    <i className="fa-solid fa-caret-down"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {motoPedido.map((item, index) => {
                                                return (
                                                    <tr key={index} className="text-center">
                                                        <th scope="row">{item.MOTO}</th>
                                                        <td>{item.PEDIDOS}</td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className='col m-0 p-0'>
                                <div className='bg-secondary text-center text-light bg-gradient'>
                                    Cantidad Motos x Tiempo
                                </div>
                                <div className='table-responsive overflow-auto' style={{ height: "350px" }}>
                                    <table className="table table-sm table-dark table-hover table-striped">
                                        <thead>
                                            <tr className='text-center'>
                                                <th className="col-6">Rango Horas</th>
                                                <th className="col-4">
                                                    <div className='container-fluid m-0 p-0'>
                                                        <div className='row row-cols-2 g-1'>
                                                            <div className='col-8 m-0 p-0'>
                                                                # Motos
                                                            </div>
                                                            <div className='col-4 m-0 p-0'>
                                                                <button className='btn btn-sm m-0 p-0 mx-1 text-light'
                                                                    onClick={() => ordenarListaMotoTiempo(true)}>
                                                                    <i className="fa-solid fa-sort-up"></i>
                                                                </button>
                                                                <button className='btn btn-sm m-0 p-0 text-light'
                                                                    onClick={() => ordenarListaMotoTiempo(false)}>
                                                                    <i className="fa-solid fa-caret-down"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </th>
                                                <th className='col-2'>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {motosPorHora.map((item, index) => {
                                                return (
                                                    <tr key={index} className="text-center">
                                                        <th scope="row">{DateConverter.getSoloHora(item.horaini) + " -- " + `${item.horafin == null ? parseInt(DateConverter.getSoloHora(item.horaini)) + 1 : DateConverter.getSoloHora(item.horafin)}`}</th>
                                                        <td>{item.cantidad}</td>
                                                        <td>
                                                            <button className='btn btn-sm text-light' onClick={() => verMotos(item)}>
                                                                <i className="fa-solid fa-ellipsis fa-xl"></i>
                                                            </button>
                                                        </td>
                                                    </tr>
                                                )
                                            })}
                                            <tr className='text-center'>
                                                <th>Total Motos</th>
                                                <td>{motoPedido.length}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </>}
            {ventana == 1 && <>
                {datosOn && <GraficaMotosDos pedidos={pedidos} valMaximo={valMaximo} tipo={'R'} color='n' />}
                {datosOn && <GraficaMotosDos pedidos={pedidos} valMaximo={valMaximoD} tipo={'M'} color='n' />}
            </>}
            {ventana == 2 && <ConfigurarEnvioReporte regional={regional} setVentana={setVentana} />}
            {ventana == 3 && <GraficaCallCenter fecha={fecha} idSucursal={idSucursal} sucursales={sucursales} />}
            <Modal show={showDetalle} onHide={() => setShowDetalle(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="xl"
                contentClassName='bg-dark bg-gradient text-light'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <div className='container-fluid w-100'>
                        {tipoModal == 'D' && <div className='row row-cols-2 g-1'>
                            <div className='col col-6 my-auto fw-bold'>
                                Detalle Pedido {selectItem.PEDIDO_NRO}
                            </div>
                            {selectItem.DETALLE !== null && selectItem.DETALLE !== undefined && <div className='col col-6'>
                                <table className="table table-sm ">
                                    <thead className='text-light' style={{ fontSize: '10px' }}>
                                        <tr>
                                            <th scope="col">#</th>
                                            <th scope="col">Producto</th>
                                            <th scope="col">Precio</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-light' style={{ fontSize: '10px' }}>
                                        {selectItem.DETALLE.map((item, index) => {
                                            return (
                                                <tr key={index}>
                                                    <th scope="row">{item.CANTIDAD}</th>
                                                    <td>{item.DESCRIPCION}</td>
                                                    <td>{item.PRECIO}</td>
                                                </tr>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </div>}
                        </div>}
                        {tipoModal == 'R' && <div className='text-center'>Resumen Reporte</div>}
                    </div>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    {tipoModal == 'D' && <DetallePedido info={selectItem} sucursal={sucursalSelect} />}
                    {tipoModal == 'R' && <ResumenMotos pedidos={pedidos} valMaximouno={valMaximo} valMaximodos={valMaximoD} setLoading={setLoading} fecha={fecha} sucursal={sucursalSelect} />}
                </Modal.Body>
                <Modal.Footer>
                    {selectItem.DIRECCION !== null && <div className='text-center text-light'>{selectItem.DIRECCION}</div>}
                </Modal.Footer>
            </Modal>
            <Modal show={showVerMoto} onHide={() => setShowVerMoto(false)}
                aria-labelledby="contained-modal-title-vcenter"
                contentClassName='bg-dark bg-gradient text-light'>
                <Modal.Header closeButton closeVariant='white' bsPrefix='modal-header m-0 p-0 px-2'>
                    <Modal.Title>Motos Activas</Modal.Title>
                </Modal.Header>
                <Modal.Body bsPrefix='modal-body m-0 p-0'>
                    <ul className="list-group list-group-sm">
                        {selectMotoHora.map((item, index) => {
                            return (
                                <li className="list-group-item m-0 p-0 text-center bg-secondary bg-gradient" key={index}>{item.IDENTIFICADOR}</li>
                            )
                        })}
                    </ul>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ControlMotosPrincipal
